import { Header } from "../../components/Header";
import Footer from "../../components/Footer/Footer";
import styles from "./Information.module.scss";
import { useEffect, useState } from 'react';
import { API_BASE } from "../../config/api";

interface ApiResponse {
  title: string;
  content: string;
}

export const Information = ({ type }: { type?: 'refunds' | 'offer' }) => {
  const [refundsData, setRefundsData] = useState<ApiResponse | null>(null);
  const [offerData, setOfferData] = useState<ApiResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [atFooter, setAtFooter] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [refundsResponse, offerResponse] = await Promise.all([
          fetch(`${API_BASE}/documents/ticket-refund-policy/`),
          fetch(`${API_BASE}/documents/public-offer/`)
        ]);

        if (!refundsResponse.ok || !offerResponse.ok) throw new Error('Ошибка загрузки');

        const [refundsResult, offerResult] = await Promise.all([
          refundsResponse.json(),
          offerResponse.json()
        ]);

        setRefundsData(refundsResult);
        setOfferData(offerResult);
      } catch (err) {
        console.error('Ошибка:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);

    // следим за футером
    const footer = document.querySelector("footer");
    let observer: IntersectionObserver | null = null;

    if (footer) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => setAtFooter(entry.isIntersecting));
        },
        { threshold: 0.1 }
      );
      observer.observe(footer);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (observer && footer) observer.unobserve(footer);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const content = {
    refunds: (
      <>
        {loading && <div>Загрузка...</div>}
        {refundsData && (
          <div>
            <div className="textContainer" dangerouslySetInnerHTML={{ __html: refundsData.content }} />
          </div>
        )}
      </>
    ),
    offer: (
      <>
        {loading && <div>Загрузка...</div>}
        {offerData && (
          <div>
            <div className="textContainer" dangerouslySetInnerHTML={{ __html: offerData.content }} />
          </div>
        )}
      </>
    )
  };

  return (
    <>
      <Header />
      <main>
        <div className={styles.Information}>
          {content[type || 'refunds']}
        </div>

        {/* Кнопка "Наверх" */}
        {showScrollTop && (
          <button
            className={`${styles.scrollTop} ${atFooter ? styles.hidden : ""}`}
            onClick={scrollToTop}
            aria-label="Наверх"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
              <path d="M12 8L7 13M12 8l5 5M12 4L7 9M12 4l5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>Наверх</span>
          </button>
        )}
      </main>
      <Footer />
    </>
  );
};
